import _ from '@lodash';
import { useSelector } from 'react-redux';
import { useParams, Redirect } from 'react-router';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormFileInputField from 'modules/ui/editform/fields/EditFormFileInputField';
import UserProfileEditService from '../service/UserProfileEditService';

const config = {
	key: 'userProfileForm',
	text: 'Profile',
	textKey: 'userProfile',
	service: UserProfileEditService,
	icon: 'person',
	hideBackLink: true,
	noNavigationAfterSave: true,
	fields: [
		{
			key: 'name',
			text: 'Name',
			textKey: 'name',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'email',
			text: 'E-mail',
			textKey: 'email',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'profilePicture',
			text: 'Profile Picture',
			textKey: 'profilePicture',
			component: EditFormFileInputField,
			required: true
		},
		{
			key: 'password',
			text: 'Password',
			textKey: 'password',
			component: EditFormTextField,
			required: true,
			type: 'password',
			autoComplete: 'new-password'
		},
		{
			key: 'passwordAgain',
			text: 'Password again',
			textKey: 'passwordAgain',
			component: EditFormTextField,
			required: true,
			type: 'password',
			autoComplete: 'new-password'
		}
	]
};

function UserProfileEditForm() {
	const user = useSelector(({ auth }) => auth.user);
	const { id } = useParams();
	if (_.isUndefined(id)) {
		return <Redirect to={`/profile/${user.data.id}`} />;
	}
	if (Number.parseInt(id, 10) !== user.data.id) {
		return <Redirect to={`/profile/${user.data.id}`} />;
	}

	return <EditFormPage config={config} />;
}

export default UserProfileEditForm;
